module.exports = __webpack_public_path__ + "img/how_it_works_4.2b172250.png";